module.exports = __webpack_public_path__ + "img/38.62a1d862.jpg";